import * as React from "react";
import { Grid, TextField } from "@mui/material";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import moment from "moment";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { Button, Col, DatePicker, Flex, message, Row } from "antd";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { showMessage } from "../../Components/Utils/message";
import { ProductOutlined } from "@ant-design/icons";
import InputBox from "../../Components/common/InputBox";
import { decodeId } from "../../Components/common/CommonFun";


const Auth = new AuthService();

export default function Roster(props) {

  const navigate = useNavigate();
  const params = useParams();
  var layoutDispatch = useLoadingDispatch();
    const decodedID = decodeId(params?.id)

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [helpers, setHelpers] = React.useState([]);
  const [selectedHelpers, setSelectedHelpers] = React.useState([]);
  const [availableHelpers, setAvailableHelpers] = React.useState([]);
  const [rosterDate, setRosterDate] = React.useState(dayjs());
  const [notes, setNotes] = React.useState("");

  console.log('selectedHelpers', selectedHelpers);

  const helperItem = {
    label: "Avaiable Helpers",
    value: availableHelpers || [],
    options: helpers,
    onChange: (values) => {
      setAvailableHelpers(values)
    },
    icon: <ProductOutlined style={{ color: "#1677ff" }} />,
    readOnly: false,
    type: 'select-multiple',
    data: 'constants',
  }

  const getRosterHelpers = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/warehouse-roster/warehouse-roster-meta?roster_date=${dayjs(rosterDate).format('YYYY-MM-DD')}`);

      if (res?.ack) {
        let selected_helpers = [];
        const helpers1 = res?.helpers
        helpers1.map((helper) => {
          if (Number(helper.fixed) > 0) {
            helper.title += ' (F)';
            selected_helpers.push(helper);
          }
          else {
            helper.title += ' (E)';
          }
        });

        const helpers2 = res?.helpers?.map(helper => ({
          ...helper,
          title: helper.title + (Number(helper.fixed) > 0 ? " (F)" : " (E)")
        }));

        // just IDs of fixed helpers
        const selected_helpers1 = helpers2
          .filter(helper => Number(helper.fixed) > 0)
          .map(helper => helper.id);

        // setHelpers(helpers1);
        setAvailableHelpers(selected_helpers1);


        setHelpers(helpers1);
        setSelectedHelpers(selected_helpers);
      } else {
        setHelpers([]);
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const getRosterByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/warehouse-roster/warehouse-roster?id=${id}`);
      if (res?.ack) {
        setRosterDate(res?.roster?.roster_date ? dayjs(res?.roster?.roster_date, 'YYYY-MM-DD') : null);
        setNotes(res?.roster?.notes);
        const selected_helpers1 = res.selected_helpers;

        try {
          const res1 = await Auth.fetch(`/warehouse-roster/warehouse-roster-meta?roster_date=${dayjs(res?.roster?.roster_date).format('YYYY-MM-DD')}`);
          if (res1?.ack) {
            let selected_helpers = [];
            // const helpers1 = res1.helpers;
            const helpers1 = res1?.helpers?.map(helper => ({
              ...helper,
              title: helper.title + (Number(helper.fixed) > 0 ? " (F)" : " (E)")
            }));

            selected_helpers1.map((sh) => {
              let h = helpers1.filter(h1 => h1.id == sh.warehouse_helper_id);
              if (h.length > 0) {
                selected_helpers.push(h[0]);
              }
            });

            const helperIds = new Set(helpers1.map(h => h.id));
            const selected_helpers2 = selected_helpers1
              .map(sh => sh.warehouse_helper_id)
              .filter(id => helperIds.has(id));


            setAvailableHelpers(selected_helpers2)
            setSelectedHelpers(selected_helpers);
            setHelpers(helpers1);
          } else {
          showMessage('error', res1?.message)
            setHelpers([])
          }
        } catch (err) {
          console.log(err);
      showMessage('error','something went wrong')

        }
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error','something went wrong')
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  React.useEffect(() => {
    if (id > 0) {
      getRosterByID();
    } else {

      getRosterHelpers()
    }
  }, [id]);


  const onChangeHelper = (event, values) => {
    console.log(values)
    setSelectedHelpers(values)
  }

  const submitRoster = async () => {
    const selectedHelpersNew = helpers.filter((d) =>
      availableHelpers?.includes(d.id)
    );
    const isUpdate = id > 0;
    const dataToSend = {
      selected_helpers: selectedHelpersNew,
      notes: notes,
    };
    if (!isUpdate) {
      dataToSend.roster_date = dayjs(rosterDate).format("YYYY-MM-DD");
    } else {
      dataToSend.id = id;
    }
    const method = id > 0 ? "PUT" : "POST";
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/warehouse-roster/warehouse-roster`, {
        method: method,
        body: JSON.stringify(dataToSend),

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        navigate("/rosters");
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleChangeDate = (date) => {
    setRosterDate(date);
    setSelectedHelpers([]);

    showLoading(layoutDispatch);
    Auth.fetch(`/warehouse-roster/warehouse-roster-meta?roster_date=${dayjs(date).format('YYYY-MM-DD')}`)
      .then((resV) => {
        hideLoading(layoutDispatch);
        if (resV.ack) {

          let helpers1 = resV.helpers;
          let selected_helpers = [];
          helpers1.map((helper) => {
            if (Number(helper.fixed) > 0) {
              helper.title += '(F)';
              selected_helpers.push(helper);
            }
            else {
              helper.title += '(E)';
            }
          });
          setSelectedHelpers(selected_helpers);
          setHelpers(helpers1);

          const helpers2 = resV?.helpers?.map(helper => ({
            ...helper,
            title: helper.title + (Number(helper.fixed) > 0 ? " (F)" : " (E)")
          }));

          // just IDs of fixed helpers
          const selected_helpers1 = helpers2
            .filter(helper => Number(helper.fixed) > 0)
            .map(helper => helper.id);

          setAvailableHelpers(selected_helpers1)

        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div>
      <h1> {id > 0 ? "Update" : "Add"} Roster </h1>
      <DatePicker
        format={"DD-MM-YYYY"}
        value={rosterDate}
        onChange={(date) => {
          // setRosterDate(dateStr);
          handleChangeDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
        }}
        style={{
          width: "200px",
          marginBottom: "20px",
        }}
        placeholder="Select date"
      />
      {
        helpers?.length > 0 && (
          <Row>
            <Col span={16}>
              <InputBox inputItem={helperItem} inputType='select' />
            </Col>
          </Row>
        )
      }

      {/* <Grid container rowSpacing={3} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
        


        <Grid item xs={12}>
          {helpers.length > 0 &&
            <Autocomplete
              multiple
              id="helpers"
              style={{ width: "80%" }}
              options={helpers}
              getOptionLabel={(option) => option.title}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterSelectedOptions
              value={selectedHelpers}
              onChange={onChangeHelper}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Available Helpers"
                  placeholder="Available Helpers"
                />
              )}
            />
          }
        </Grid>
      </Grid> */}
      <Row style={{ marginTop: "20px" }} gutter={16}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <span>
            Notes:
          </span>
          <TextArea value={notes} onChange={(e) => setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
        </Col>
      </Row>
      <Flex justify="end" gap={5}>
        <Button onClick={() => navigate('/rosters')}>Cancel</Button>
        <Button type="primary" onClick={submitRoster}>Save</Button>
      </Flex>

    </div>
  );
}
